import { useMutation, UseMutationOptions } from 'react-query';
import client from 'client';

const useUnsaveSeat = (
    eventId: number,
    sessionId: number,
    ticketId: number,
    options: UseMutationOptions = {}
) => {
    const unsaveSeatMutation = useMutation(() => {
        return client().delete(
            `/api/v2/agenda/events/${eventId}/sessions/${sessionId}/register/${ticketId}`
        );
    }, options);

    return unsaveSeatMutation;
};

export default useUnsaveSeat;
